import React from 'react';
import './Writing.css';

function Writing() {
  return (
    <main className="writing section">
      <div className="container">
        <h1 className="page-title">Writing</h1>
        <p className="subtitle" style={{ marginBottom: 'var(--space-xl)' }}>
          Thoughts and essays.
        </p>
        <div className="writing-placeholder">
          <p>Coming soon.</p>
        </div>
      </div>
    </main>
  );
}

export default Writing;
